<template>
  <div>
    <el-input-number
      size="small"
      :precision="0"
      placeholder="请输入数字"
      v-model="value"
      :controls="false"
      @blur="updateValue"
      :min="info.detectionRangeMin"
      :max="info.detectionRangeMax"
    ></el-input-number>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: null
    };
  },
  props: ["info", "index"],
  watch: {
		info: {
			handler(newValue) {
				if(newValue.fieIdValue != undefined && newValue.fieIdValue != null) {
					this.value = newValue.fieIdValue
				} else if(newValue.defaultValue) {
					this.value = newValue.defaultValue
				} else {
					this.value = null
				}
				this.updateValue()
			},
			deep: true,
			immediate: true,
		}
	},
  methods: {
    updateValue() {
      let obj = {
        type: 6,
        fieIdValue: this.value,
        fieIdId: this.info.fieIdId,
        index: this.index,
      };
      this.$emit("updateValue", obj);
    },
  },
};
</script>